import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "x-t-cell-ta-editor x-cell-editor"
};
const _hoisted_2 = {
  key: 0,
  class: "error-msg"
};
const _hoisted_3 = {
  key: 1,
  class: "x-cell-editor"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_textarea = _resolveComponent("a-textarea");
  return $props.editMode ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", {
    class: _normalizeClass({
      'inner-border': true,
      'input-error': $props.error
    })
  }, [_createVNode(_component_a_textarea, {
    style: {
      width: '100%',
      height: '100%',
      flex: 1,
      borderRadius: 0,
      padding: '1px 0'
    },
    value: $props.value,
    bordered: $setup.isFocused,
    "onUpdate:value": $setup.handleUpdateValue,
    onFocus: $setup.handleFocus,
    onBlur: $setup.handleBLur
  }, null, 8, ["value", "bordered", "onUpdate:value", "onFocus", "onBlur"]), $props.error ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString($props.error), 1)) : _createCommentVNode("", true)], 2)])) : (_openBlock(), _createElementBlock("span", _hoisted_3, [_createElementVNode("span", {
    class: _normalizeClass({
      'input-error': !!$props.error
    })
  }, _toDisplayString($props.value), 3)]));
}